import { render, staticRenderFns } from "./PublicTest.vue?vue&type=template&id=2ad192c9&scoped=true&"
import script from "./PublicTest.vue?vue&type=script&lang=js&"
export * from "./PublicTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad192c9",
  null
  
)

export default component.exports